module.exports = __webpack_public_path__ + "cy.svg?482a63747c778db23de75fcae44e22e9";